export default __webpack_public_path__ + "static/media/934.03c9a04b.png";